<template>
  <div class="card-list">
    <!-- 弹窗 -->
    <div class="container" v-show="popupVisible">
      <div class="popup">
        <div class="contentone">退出登录</div>
        <div class="contenttwo">你确定退出登录了吗？</div>
        <div class="popupbutton">
          <div class="popupbuttonone" @click="popupok">
            <img src="../../assets/images/mts/buttononex2.png" alt />
            <span>确定</span>
          </div>
          <div class="popupbuttontwo" @click="popupcancle">
            <img src="../../assets/images/mts/buttontwox2.png" alt />
            <span>取消</span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- <a-avatar
        style="margin-right:5px;"
        shape="circle"
        size="large"
        :style="{backgroundColor: color, verticalAlign: 'middle'}"
      >{{avatarValue}}</a-avatar> -->
      <a class="ant-dropdown-link" href="#">{{avatarValue}}</a>
    </div>
    <span class="quit" @click="handlerQuit">退 出</span>
    <div class="content">
      <div
        @click="handleMenuItemClick(item)"
        :key="item.alias"
        v-for="item in pdaMenuList"
        class="contentone"
      >
        <span>{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { Avatar } from "ant-design-vue";
import Vue from "vue";
Vue.use(Avatar);
export default {
  data() {
    return {
      popupVisible: false,
      avatarValue: Vue.ls.get("username")
    };
  },
  methods: {
    popupok: function() {
      // this.$router.push({ path: "/mtsmobilelogin" });
      this.$store.commit("MTS_LOGOUT_USER");
    },
    popupcancle: function() {
      this.popupVisible = false;
    },
    handlerQuit: function() {
      this.popupVisible = true;
    },
    queryPdaMenu: function() {
      this.$store.dispatch("queryPdaMenu");
    },
    handleMenuItemClick: function(obj) {
      this.$router.push({ name: obj.alias });
    },
    ...mapMutations([])
  },

  mounted() {
    this.$store.dispatch("queryPdaMenu");
  },
  watch: {},
  computed: {
    ...mapState({
      pdaMenuList: state => state.mts.pdaMenuList
    }),
    ...mapGetters([])
  },
  components: {}
};
</script>

<style lang='less' scoped>
.card-list {
  height: 100%;
  // position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: url("../../assets/images/mts/cardListBgx2.jpg") no-repeat;
  background-repeat: no-repeat;
  background-size: cover;
  font-size: 100px;
  .container {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 800;
    height: 100%;
    width: 100%;
    .popup {
      background-color: #fff;
      width: 200px;
      height: 120px;
      border-radius: 5px;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      margin-left: 20px;
      text-align: center;
      .contentone {
        font-size: 12px;
        color: #000;
        margin-top: 16px;
      }
      .contenttwo {
        font-size: 10px;
        color: #999999;
        margin-top: 8px;
      }
    }
    .popupbutton {
      height: 30px;
      width: 200px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-top: 19px;
      div {
        width: 85px;
        height: 30px;
      }
      .popupbuttonone {
        margin-left: 10px;
        margin-right: 10px;
        position: relative;
        width: 85px;
        height: 30px;
        img {
          width: 85px;
          height: 30px;
          position: absolute;
          left: 0;
          right: 0;
        }
        span {
          position: absolute;
          font-size: 12px;
          left: 0;
          right: 0;
          margin-left: auto;
          margin-right: auto;
          line-height: 30px;
        }
      }
      .popupbuttontwo {
        margin-right: 10px;
        position: relative;
        width: 85px;
        height: 30px;
        img {
          width: 85px;
          height: 30px;
          position: absolute;
          left: 0;
          right: 0;
        }
        span {
          position: absolute;
          font-size: 12px;
          left: 0;
          right: 0;
          margin-left: auto;
          margin-right: auto;
          line-height: 30px;
        }
      }
    }
  }
  div .ant-dropdown-link{
    top: 6px;
    color: #fff;
    left: 120px;
    position: absolute;
    font-size: 12px;
  }
  .quit {
    color: #fff;
    font-size: 12px;
    top: 6px;
    position: absolute;
    left: 200px;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 150px;
    padding-top: 62px;
    .contentone {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 100%;
      height: 75px;
      background: url("../../assets/images/mts/cardListContentx2.png") no-repeat;
      background-repeat: no-repeat;
      background-size: cover;
      span {
        width: 90%;
        color: #74003c;
        font-size: 12px;
      }
      div {
        width: 60%;
      }
    }
  }
}
</style>
